export default {"src":"https://fishbrain.com/_next/static/media/nebraska.9bec0f92.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};